"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
exports.EmailCanvasToolbarTemplateButton = ({ link }) => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { prefs: { view }, state: { draftEmail: draft }, } = hooks_1.useEmailCanvasContext();
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasToolbarTemplateButton", active: view === 'template', onClick: () => {
            dispatchCanvasAction({
                data: {
                    view: 'template',
                },
                type: 'prefs',
            });
        }, to: link('/template'), disabled: view === 'send' || !draft.emailTemplateVersion, osysIcon: "template", tooltip: !draft.emailTemplateVersion || !draft.emailTemplateVersion.template
            ? 'No template'
            : `Template: ${draft.emailTemplateVersion.template.name} ${draft.emailTemplateVersion.version}` }, draft.emailTemplateVersion && (react_2.default.createElement("span", { className: "text-muted small" }, draft.emailTemplateVersion.version))));
};
//# sourceMappingURL=TemplateButton.js.map